import { render, staticRenderFns } from "./coachMechanism.vue?vue&type=template&id=0ab4f61b&scoped=true&"
import script from "./coachMechanism.vue?vue&type=script&lang=js&"
export * from "./coachMechanism.vue?vue&type=script&lang=js&"
import style0 from "./coachMechanism.vue?vue&type=style&index=0&id=0ab4f61b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab4f61b",
  null
  
)

export default component.exports